module.exports = __webpack_public_path__ + "img/advance5.3e261992.png";